<template>
  <div
    class="click-to-text-widget-minimized"
    :style="{ background: widgetData.headerColor }"
  >
    <div class="body-text-semi-bold-14 lh-20 break-word text-center">
      {{ widgetData.header }}
    </div>

    <div
      v-if="widgetData.phoneNumberVisible"
      class="click-to-text-widget-minimized__phone"
    >
      {{ phoneNumber }}
    </div>
  </div>
</template>

<script lang="ts">
import { phoneService } from '@widgets/shared/services/phoneService'
import { computed, defineComponent, type PropType } from '@/composition/vue/compositionApi'
import type { ClickToTextForm } from '@/services/domain/services/forms/clickToText/types'

export default defineComponent({
  props: {
    widgetData: {
      type: Object as PropType<ClickToTextForm>,
      required: true,
    },
  },
  setup(props) {
    const phoneNumber = computed(() => phoneService.format(props.widgetData.phoneNumber))

    return {
      phoneNumber,
    }
  },
})
</script>

<style lang="scss" scoped>
.click-to-text-widget-minimized {
  min-height: 52px;
  padding: 5px 0;
  box-shadow: 0 0 8px rgba(99, 99, 99, 0.25);
  border-radius: $border-radius-md $border-radius-md 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 250px;
  justify-content: center;
  color: $white;
  cursor: pointer;

  &__phone {
    font-size: 22px;
    font-weight: $bold-font;
    line-height: 30px;
  }
}
</style>
